import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./MobileAppSlide.styles";

// TODO: placeholder content — final copy and visuals land with the mobile-app slide ticket.
const MobileAppSlide = () => {
  const { t } = useTranslation();

  return (
    <div css={styles.slide}>
      <Typography variant="h3" intention="inverse" isMarginless>
        {t(l.sideCarousel.slides.mobileApp.title)}
      </Typography>
      <Typography intention="inverse" isMarginless>
        {t(l.sideCarousel.slides.mobileApp.body)}
      </Typography>
    </div>
  );
};

export { MobileAppSlide };
